import { useContext, useMemo } from 'react';
import useSWR from 'swr';
import SchoolContext from '@/contexts/school';
import { fetcher } from '@/plugins/graphql';

const useSettings = () => {
  const { schema } = useContext(SchoolContext);

  const query = useMemo(() => {
    return `
      {
        ${schema}_school_setting(where: {deleted_at: {_is_null: true}}) {
          school_name
          school_tel
          school_mail
          school_address
          school_business_hour
          transfer_ticket_timing
        }
      }
    `;
  }, [schema]);

  const { data, mutate } = useSWR(query, fetcher, { revalidateOnFocus: false });

  const school: {
    school_name: string;
    school_tel: string;
    school_mail: string;
    school_address: string;
    school_business_hour: string;
    transfer_ticket_timing: number;
  } = useMemo(() => {
    return data?.[`${schema}_school_setting`]?.[0];
  }, [data, schema]);

  // スクール名
  const schoolName = useMemo(() => {
    return school?.school_name || '';
  }, [school]);

  const schoolTel = useMemo(() => {
    return school?.school_tel || '';
  }, [school]);

  const schoolMail = useMemo(() => {
    return school?.school_mail || '';
  }, [school]);

  const schoolAddress = useMemo(() => {
    return school?.school_address || '';
  }, [school]);

  const transferTicketTiming = useMemo(() => {
    return school?.transfer_ticket_timing || 1;
  }, [school]);

  // 営業時間
  const businessHour: {
    open: {
      hour: string;
      minute: string;
    };
    close: {
      hour: string;
      minute: string;
    };
  } = useMemo(() => {
    return school
      ? JSON.parse(school.school_business_hour.replace(/\'/g, '"'))
      : {
          open: {
            hour: '0',
            minute: '0',
          },
          close: {
            hour: '0',
            minute: '0',
          },
        };
  }, [school]);

  return {
    schoolName,
    schoolTel,
    schoolMail,
    schoolAddress,
    businessHour,
    transferTicketTiming,
    mutate,
  };
};

export default useSettings;
